var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFullscreenOn = function SvgFullscreenOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fullscreen_on_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fullscreen_on_svg__st0{fill:none}.fullscreen_on_svg__st1{stroke-linejoin:round}.fullscreen_on_svg__st1,.fullscreen_on_svg__st2{fill:none;stroke:#000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fullscreen_on_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fullscreen_on_svg__st1",
    d: "M2 8h6V2M16 2v6h6M2 16h6v6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fullscreen_on_svg__st2",
    d: "M8 8 1 1M23 1l-7 7M8 16l-7 7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fullscreen_on_svg__st1",
    d: "M16 22v-6h6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fullscreen_on_svg__st2",
    d: "m23 23-7-7"
  })));
};
export default SvgFullscreenOn;